import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const DataGridWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const DataGridTable = styled.table`
  border-spacing: 0;
  width: 100%;
  border-collapse: collapse;
`;

export const DataGridHeaderCell = styled.th`
  text-align: left;
  padding: 10px 12px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const DataGridCell = styled.td`
  padding: 8px 12px;
  vertical-align: middle;
`;

export const DataGridBody = styled.tbody``;

export const DataGridRow = styled.tr``;

export const DataGridActionsCell = styled(DataGridCell)`
  width: 1%;
  white-space: nowrap;
`;

export const AddRowButtonWrapper = styled.div`
  margin-top: 12px;
`;

export const CellInput = styled.input`
  width: 100%;
  min-width: 80px;
  padding: 6px 8px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  border: 1px solid
    ${(props) => props.theme.atlas.semantic.color.outline.default};
  border-radius: 4px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};

  &:focus {
    outline: none;
    box-shadow: ${(props) => props.theme.atlas.semantic.shadow.focus};
  }
`;
